<template>

  <div>
    <div class="container">
  
      <div class="tool-header mb-10">
        <div class="site-name">{{ site.name }}</div>
        <div class="tool-title">
          Power up your keyword strategy with silos
          <span class="material-icons video-tutorial-icon video-tutorial-icon-size"
            @click="() => {
              $store.commit('setCurrentVideoTutorialToDisplay', {
                title: 'The Reverse Silo: How it Works',
                videoLink: 'https://www.youtube.com/embed/5OYCQL0Q38A',
                description: '',
                time: '1m 41s'
              });
            }">
            videocam
          </span>
        </div>
        <div class="tool-description">Select how you want to build your silo:</div>
      </div>

      <cards-section
        :reloadUser="reloadUser"
        :site="site"
        :campaign="campaign"
        :hasUnlimitedAccess="hasUnlimitedAccess"
        :isWhiteGloveUser="isWhiteGloveUser"
        :isMissionControlSession="isMissionControlSession"
      />
  
    </div>
  
    <hr style="background-color: var(--v-gray12Color-base); height: 1px; margin: 3rem 0;" />

    <div class="container">
      <list-section
        :reloadUser="reloadUser"
        :site="site"
        :campaign="campaign"
        :hasUnlimitedAccess="hasUnlimitedAccess"
        :isWhiteGloveUser="isWhiteGloveUser"
        :isMissionControlSession="isMissionControlSession"
      />
    </div>

    <hr style="background-color: var(--v-gray12Color-base); height: 1px; margin: 3rem 0;" />
  
    <div class="container">
  
      <div
        class="white-common-box d-flex"
        style="padding: 60px 42px; gap: 28px;"
      >
  
        <div style="flex: 1; text-align: center;">
          <img src="/static/keyword-strategy-image.svg" style="width: 450px;">
        </div>
  
        <div style="flex: 1;">
          <div style="max-width: 450px;">
            <div
              class="mb-6 mt-4"
              style="font-size: 1.4rem; font-weight: 800; line-height: 1.6;"
            >Create your Keyword Strategy with content silos</div>
            <div
              class="mb-6"
              style="font-size: 1.1rem; line-height: 1.6;"
            >Silos boost your rankings and fuel your target keyword with structured supporting content.</div>
            <v-btn color="#00C362"
              class="whiteColor--text text-none font-weight-bold"
              large
              target="_blank"
              href="https://help.pageoptimizer.pro/article/seo-reverse-silo-content"
            >
              Learn how to build silos
            </v-btn>
          </div>
        </div>
  
      </div>
      
    </div>

  </div>

</template>

<script>
import ListSection from './ListSection.vue'
import CardsSection from './CardsSection.vue'

export default {
  props: ['site', 'campaign', 'hasUnlimitedAccess', 'isWhiteGloveUser', 'isMissionControlSession', 'reloadUser'],
  components: {
    ListSection,
    CardsSection,
  },
  data () {
    return {
      
    }
  },
  computed: {
    
  },
  watch: {
    
  },
  methods: {
    
  },
  mounted () {
    
  }
}
</script>

<style lang="scss" scoped>
@import "./../styles.scss";
</style>